export default {"src":"/assets/turbo/46c59f30/jelmolich/_next/static/media/favicon.ccaae7c2.ico","height":48,"width":48,"blurWidth":0,"blurHeight":0};